const localStorageName = "user-role";

export function getRole(): string | null {
    return localStorage.getItem(localStorageName);
}

export function setRole(token: string) {
    localStorage.setItem(localStorageName, token);
}